import { FC, useState } from "react";
import { tokens } from "@/tokens";

interface ExampleChatMessageCardProps {
  message: string;
  onClick: (message: string) => void;
  style?: React.CSSProperties;
}

const ExampleChatMessageCard: FC<ExampleChatMessageCardProps> = ({
  message,
  onClick,
  style,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    onClick(message);
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 34,
        paddingRight: 34,
        backgroundColor: tokens.bg.surface,
        border: "1px solid #F0EFED",
        borderRadius: tokens.radius.lg,
        maxWidth: 480,
        textAlign: "center",
        fontSize: tokens.fontSize.xl,
        cursor: "pointer",
        opacity: isHovered ? 0.7 : 1,
        transition: "opacity 0.2s ease, transform 0.2s ease",
        transform: isHovered ? "translateY(-2px)" : "translateY(0px)",
        boxShadow: isHovered
          ? "0 4px 12px rgba(0, 0, 0, 0.1)"
          : "0 1px 3px rgba(0, 0, 0, 0.05)",
        ...style,
      }}
    >
      &quot;{message}&quot;
    </div>
  );
};

export default ExampleChatMessageCard;
